<template>
    <div class='key-container'>
        <div class='keyboard' @click="_handleKeyPress">
            <div class='key-row'>
                <div class='key-cell' data-num='1'>1</div>
                <div class='key-cell' data-num='2'>2</div>
                <div class='key-cell' data-num='3'>3</div>
                <div class='key-cell' data-num='D'>
                    <img :src="deleteImg" data-num='D' class='delete-image'>
                </div>
            </div>
            <div class='key-row'>
                <div class='key-cell' data-num='4'>4</div>
                <div class='key-cell' data-num='5'>5</div>
                <div class='key-cell' data-num='6'>6</div>
                <div class='key-cell disabled' data-num='-1'/>
            </div>
            <div class='key-row'>
                <div class='key-cell' data-num='7'>7</div>
                <div class='key-cell' data-num='8'>8</div>
                <div class='key-cell' data-num='9'>9</div>
                <div class='key-cell disabled' data-num='-1'/>
            </div>
            <div class='key-row'>
                <div class='key-cell zero' data-num='0'>0</div>
                <div class='key-cell' data-num='.'>.</div>
                <div class='key-cell disabled' data-num='-1'/>
            </div>
            <div :class="money.length > 0 ? 'key-confirm have-num' : 'key-confirm no-num'" data-num='S'>
                <div class='key-confirm-title' data-num='S'>确认</div>
                <div class='key-confirm-title' data-num='S'>支付</div>
            </div>
        </div>
    </div>
</template>

<script>
import deleteImg from '../../../assets/image/delete.png'

export default {
    name: "KeyBoard",

    data() {
        return {
            money: '',
            deleteImg: deleteImg
        }
    },

    methods: {
        //处理按键
        _handleKeyPress: function (e) {
            e.stopPropagation()
            const _this = this
            let num = e.target.dataset.num;

            //不同按键处理逻辑
            // -1 代表无效按键，直接返回
            if (!num || num == -1) {
                return false
            }

            switch (String(num)) {
                //小数点
                case '.':
                    this._handleDecimalPoint();
                    break;
                //删除键
                case 'D':
                    this._handleDeleteKey();
                    break;
                //清空键
                case 'C':
                    this._handleClearKey();
                    break;
                //确认键
                case 'S':
                    this._handleConfirmKey();
                    break;
                default:
                    this._handleNumberKey(num);
                    break;
            }
            setTimeout(() => {
                this.$emit('getMoney', _this.money)
            })

        },
        //处理小数点函数
        _handleDecimalPoint: function () {
            if (this.money.length < 9) {
                //如果包含小数点，直接返回
                if (this.money.indexOf('.') > -1) return false;
                //如果小数点是第一位，补0
                if (!this.money.length) {
                    this.money = '0.'
                } else {
                    //如果不是，添加一个小数点
                    this.money = this.money + '.'
                }
            }
        },
//处理删除键
        _handleDeleteKey: function () {
            let S = this.money;
            //如果没有输入，直接返回
            if (!S.length) return false;
            //否则删除最后一个
            this.money = S.substring(0, S.length - 1)
        },
//处理清空键
        _handleClearKey: function () {
            this.money = ''
        },
        //处理数字
        _handleNumberKey: function (num) {
            let S = this.money;
            if (this.money.length < 6) {
                //如果有小数点且小数点位数不小于2
                if (S.indexOf('.') > -1 && S.substring(S.indexOf('.') + 1).length < 2)
                    this.money = S + num
                //没有小数点
                if (!(S.indexOf('.') > -1)) {
                    //如果第一位是0，只能输入小数点
                    if (num == 0 && S.length == 0)
                        this.money = '0.'
                    else {
                        if (S.length && Number(S.charAt(0)) === 0) return;
                        this.money = S + num
                    }

                }

            } else {
                if (S.indexOf('.') > -1 && S.substring(S.indexOf('.') + 1).length < 2)
                    this.money = S + num
            }

        },
        //提交
        _handleConfirmKey: function () {
            let newMoney = this.money;
            //未输入
            if (!newMoney.length) {
                return false;
            }
            //将 8. 这种转换成 8.00
            if (newMoney.indexOf('.') > -1 && newMoney.indexOf('.') == (newMoney.length - 1))
                newMoney = Number(newMoney.substring(0, newMoney.length - 1)).toFixed(2);
            //保留两位
            newMoney = Number(newMoney).toFixed(2);
            if (newMoney == '0.00') {
                return false;
            }
            this.$emit('submitPay', this.newMoney)
            // const requestMoney = Number(newMoney) * 100
            // let payData = {
            // 	"order_original_total": requestMoney,
            // 	"source_mtoken": this.props.businessMis.mtoken,
            // 	"payment_type": 1,
            // 	"openid": openid
            // }

            // payWxApi(payData).then(res => {
            // 	if (res.error == 0 && res.data) {
            // 		this.wxPay(res.data, newMoney)
            // 	}
            // })
        },
    }
}
</script>

<style scoped>
.key-container {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: space-between;
}

.input-box {
    font-size: 35px;
    font-weight: bold;
    height: 40px;
    border-bottom: 1px solid #aaa;
    padding: 10px 15px;
    text-align: right;
    width: 90%;
}

.keyboard {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 17rem;
    width: 100%;
    background: #F7F7F7;
}

.keyboard .key-row {
    border: none;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    position: relative;
    margin: 7px 0;
    padding: 0 2px;
    height: 3.7rem;
    line-height: 3.7rem;
}

.keyboard .key-row::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    color: #d5d5d6;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}

.keyboard .key-cell {
    flex: 1;
    width: 6rem;
    height: 3.5rem;
    line-height: 3.5rem;
    text-align: center;
    position: relative;
    color: #010000;
    border: none;
    border-radius: 8px;
    font-size: 2rem;
    margin: 0 5px;
    background: #FFFFFF;
}

.zero {
    flex: 2 !important;
    margin: 0 7px !important;
    padding-left: 9px;
}

.keyboard .key-cell::after {
    content: '';
    position: absolute;
    overflow: hidden;
    top: 0;
    right: 0;
    bottom: 0;
    height: 200%;
    background: #FFFFFF;
    color: #d5d5d6;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}

.keyboard .key-cell:nth-last-child(1)::after {
    border-right: 0;
}

.keyboard .disabled {
    visibility: hidden;
}

.have-num {
    background: #1296DB;
}

.no-num {
    background: #9ad3f0;
}

.delete-image {
    position: absolute;
    width: 3.2rem;
    height: 3.2rem;;
    top: 50%;
    left: 50%;
    margin-top: -1.6rem; /* 高度的一半 */
    margin-left: -1.6rem; /* 宽度的一半 */

}

.keyboard .key-confirm {
    position: absolute;
    text-align: center;
    height: 11.8rem;
    width: 22%;
    z-index: 9999;
    line-height: 11.8rem;
    right: 0;
    color: #fff;
    font-size: 17px;
    bottom: 1px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 7px;
    border-radius: 8px;
    border: none;
}

.key-confirm-title {
    color: #fff;
    font-size: 20px;
    height: 25px;
    line-height: 25px;
}

</style>

